import '../vendor';

import '../general/ofi';

import './game-loto/game-loto-slider';
import './game-loto/game-squares-slider';
import './game-loto/modal-square';
import './game-loto/modal-square-image';
import './one-exponat/modal-exponat';


// WEBPACK FOOTER //
// ./src/js/pages/game-loto.js